import { BaseService } from './BaseService';
import { SuccessWareMasterFieldsRepository, type SuccessWareMasterField } from '../repositories/SuccessWareMasterFieldsRepository';

export class SuccessWareMasterFieldsService extends BaseService {
  private fieldRepository: SuccessWareMasterFieldsRepository;

  constructor() {
    super();
    this.fieldRepository = new SuccessWareMasterFieldsRepository();
  }

  /**
   * Get all fields with optional filtering by entity type
   */
  async getAllFields(entityType?: string) {
    return this.fieldRepository.getAllFields(entityType);
  }

  /**
   * Get fields for a specific entity type
   */
  async getFieldsByEntity(entityType: string) {
    return this.fieldRepository.getFieldsByEntity(entityType);
  }

  /**
   * Get a single field by entity type and field name
   */
  async getField(entityType: string, fieldName: string) {
    return this.fieldRepository.getField(entityType, fieldName);
  }

  /**
   * Update field description or notes (user-editable)
   */
  async updateField(id: string, updates: Pick<SuccessWareMasterField, 'description' | 'notes'>) {
    return this.fieldRepository.updateField(id, updates);
  }

  /**
   * Search fields by text
   */
  async searchFields(searchText: string, entityType?: string) {
    if (!searchText || searchText.trim().length === 0) {
      return this.getAllFields(entityType);
    }
    return this.fieldRepository.searchFields(searchText.trim(), entityType);
  }

  /**
   * Get unique entity types
   */
  async getEntityTypes() {
    return this.fieldRepository.getEntityTypes();
  }

  /**
   * Get field statistics grouped by entity type
   */
  async getFieldStats() {
    return this.fieldRepository.getFieldStats();
  }

  /**
   * Get only imported fields
   */
  async getImportedFields(entityType?: string) {
    return this.fieldRepository.getImportedFields(entityType);
  }
}
